import { render } from "./item_adjustment.vue?vue&type=template&id=4dc830e8"
import script from "./item_adjustment.vue?vue&type=script&lang=js"
export * from "./item_adjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__